import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.development';
import { PaymentService } from '../payment/payment.service';
import { IVerifiedUserPayload } from 'src/app/interface/notes.interface';
import { IUserDetail } from 'src/app/interface/user.interface';

enum APIEnum {
  SEND_OTP = 'info_portal/send_otp',
  VERIFY_OTP = 'info_portal/verify_otp',
}

@Injectable({
  providedIn: 'root'
})
export class UserVerificationService {

  constructor(private http: HttpClient, private paymentService: PaymentService) { }

  private readonly STORAGE_KEY = 'verifiedUser';
  // private readonly EXPIRY_TIME = 60 * 60 * 1000; // 60 minutes in milliseconds
  private readonly EXPIRY_TIME = 3 * 60 * 1000; // 60 minutes in milliseconds

  verify_otp (body: {
    otp: string;
    mobile: string;
    full_name: string;
  } ) {
    const url = environment.baseUrl + APIEnum.VERIFY_OTP;
    return this.http.post(url, body);
  }

  send_otp (body: {
    mobile: string;
    full_name: string;
  } ) {
    const url = environment.baseUrl + APIEnum.SEND_OTP;
    return this.http.post(url, body);
  }

  saveVerifiedUser(user_detail: IUserDetail): void {
    const data = {
      timestamp: Date.now(),
      token: this.paymentService.token,
      user_detail
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
  }

  // Check if user is still verified within the 60-minute window
  getVerifiedUser(): IVerifiedUserPayload | null {
    const storedData = localStorage.getItem(this.STORAGE_KEY);
    if (!storedData) return null;

    const verifiedData: IVerifiedUserPayload = JSON.parse(storedData);
    if(verifiedData?.token != this.paymentService.token) {
      localStorage.removeItem(this.STORAGE_KEY);
      return null
    };
    return (Date.now() - verifiedData?.timestamp) < this.EXPIRY_TIME ? verifiedData : null;
  }


}
